import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Page, Carousel } from 'src/app/interfaces/strapi';

import StrapiService from 'src/app/services/strapi.service';
import environment from 'src/environments/environment';

@Component({
    selector: 'app-page',
    templateUrl: './page.component.html',
    styleUrls: ['./page.component.scss'],
})
export class PageComponent {
  protected pageData: Page = <Page>{};

  public pageRetrievalError = false;

  constructor(
    protected readonly titleService: Title,
    protected readonly metaService: Meta,
    public readonly strapi: StrapiService
  ) {}

  protected setMetas() {
    this.titleService.setTitle(
      this.pageData.browser_title ?? environment.defaultTitle
    );
    this.metaService.updateTag({
      name: 'description',
      content: this.pageData.meta_description ?? environment.defaultDescription,
    });
  }

  protected parsePageData(data: Record<string, any>): void {
    this.pageData.title = String(data['title']);

    this.pageData.browser_title = String(data['browser_title']);

    this.pageData.meta_description = String(data['meta_description']);
    if (!data) return;
    if (data['banner']) {
      if (!data['banner'].data) return;
      this.parseBanner(data['banner'].data.attributes);
    }

    if (data['banner_alt']) {
      if (!data['banner_alt'].data) return;
      this.parseBanner(data['banner_alt'].data.attributes, true);
    }
  }

  protected parseBanner(banner: any, alt: boolean = false) {
    if (banner.banner_type === 'carousel') {
      if (alt) this.pageData.carousel_alt = <Carousel>banner;
      else this.pageData.carousel = <Carousel>banner;
    }
  }
}
